(ns ycweb.app.admin.wholesale.clientorders.clientorder.common
  (:require
   [util.transform :as trf]))

(def es-yuppiechef-customer-uuid "cf8278f0-239c-4bfd-90f3-dd9b1e63395a")

(def manager-permission
  "SiteAdmin:Wholesale:Manager:ClientOrder")

(def dev-permission
  "SiteAdmin:Teams:Development")

(def view-permission
  "SiteAdmin:Wholesale:ClientOrder:View")

(def override-price-permission
  "SiteAdmin:Wholesale:ClientOrder:Override:Price")

(def view-permission-set
  #{dev-permission view-permission})

(def edit-permission
  "SiteAdmin:Wholesale:ClientOrder:Edit")

(def edit-permission-set
  #{dev-permission edit-permission})

(def edit-invoices
  "SiteAdmin:Wholesale:ClientOrder:Edit:Invoices")

(def edit-credit-notes
  "SiteAdmin:Wholesale:ClientOrder:Edit:CreditNotes")

(def edit-manual-journals
  "SiteAdmin:Wholesale:ClientOrder:Edit:ManualJournals")

(def back-order-permission
  "SiteAdmin:Wholesale:ClientOrder:Backorder")

(defn finance-status [finance-data status-info]
  (let [invoice-status (:invoice/status status-info)
        order-status (:client-order/status status-info)
        credit-notes
        (when (:invoice/id status-info)
          finance-data)

        credit-notes-statuses (when credit-notes (map :status credit-notes))
        credit-note-ids (when credit-notes (map :id credit-notes))

        credit-note-allocations-total
        (if credit-note-ids
          (reduce #(+ %1 (:amount %2))
            0
            (mapcat :allocations finance-data))
          0)

        credit-notes-total (reduce #((fnil + 0 0) %1 (get %2 :total 0)) 0 credit-notes)

        remaining-credit-note-allocations (- credit-notes-total credit-note-allocations-total)]

    (cond
      (and
        (pos? credit-note-allocations-total)
        (zero? remaining-credit-note-allocations))
      "Credit Allocated"

      (and
        credit-notes-statuses
        (contains? (set credit-notes-statuses) "Authorised"))
      "Crediting"

      (= invoice-status "Paid")
      "Paid"

      (= invoice-status "Authorised")
      "Invoiced"

      (and
        (= invoice-status "Draft")
        (= order-status "Delivered"))
      "Invoicing"

      :else
      "N/A")))

(defn fulfilment-status [status-info]
  (let [{:client-order/keys [picked packed ready-picking]} status-info
        picked? (trf/toboolean picked)
        packed? (trf/toboolean packed)
        ready-picking? (trf/toboolean ready-picking)
        order-status (:client-order/status status-info)
        tag-set (set (map :name (:tags status-info)))
        backorder? (contains? tag-set "Backorder")]
    (cond
      (and
        backorder?
        (= "Ready to Ship" order-status)
        (false? ready-picking?))
      "N/A"

      (and
        (= "Ready to Ship" order-status)
        (false? ready-picking?))
      "Queued"

      (and
        (= "Ready to Ship" order-status)
        (true? ready-picking?)
        (false? picked))
      "Picking"

      (and
        (= "Ready to Ship" order-status)
        (true? ready-picking?)
        (true? picked?)
        (false? packed?))
      "Packing"

      (and
        picked?
        packed?
        (= "Ready to Ship" order-status))
      "Shipping"

      (contains? #{"Sent to Courier" "Delivered"} order-status)
      "Shipped"

      :else
      "N/A")))

(defn sale-order-status [wholesale-statuses status-info]
  (let [tag-set (set (map :name (:tags status-info)))
        backorder? (contains? tag-set "Backorder")
        provisional-order (contains? tag-set "Provisional Order")]
    (cond
      backorder?
      "Backorder"

      provisional-order
      "Provisional Order"

      :else
      (get wholesale-statuses (:client-order/status status-info)))))

(defn calculate-wholesale-statuses [wholesale-statuses finance-data status-info]
  {:order-status (sale-order-status wholesale-statuses status-info)
   :fulfilment-status (fulfilment-status status-info)
   :finance-status (finance-status finance-data status-info)})

(defn add-wholesale-statuses [wholesale-statuses finance-data client-order tags]
  (let [status-info
        {:client-order/status (:status client-order)
         :client-order/picked (:picked client-order)
         :client-order/packed (:packed client-order)
         :client-order/ready-picking (:readypicking client-order)
         :invoice/status (:invoice_status client-order)
         :invoice/id (:invoice_id client-order)
         :invoice/invoice-date (:invoice_date client-order)
         :tags tags}

        calculated-wholesale-statuses
        (calculate-wholesale-statuses wholesale-statuses finance-data status-info)]

    (merge client-order calculated-wholesale-statuses)))

(defn check-stock-status [items]
  (let [product-items (remove #(= (:variation/features %) "Service") items)
        zero-stock?
        (fn [item]
          (zero? (:client-order-item/freestock item 0)))
        partial-stock?
        (fn [item]
          (and
            (pos? (:client-order-item/freestock item 0))
            (> (:client-order-item/qty item 0) (:client-order-item/freestock item 0))))
        zero-stock-items (filter zero-stock? product-items)
        partial-stock-items (filter partial-stock? product-items)]
    {:all-items-count (count product-items)
     :zero-stock-count (count zero-stock-items)
     :partial-stock-count (count partial-stock-items)
     :zero-stock-items zero-stock-items
     :partial-stock-items partial-stock-items}))
